import styled from '@emotion/styled';

import { P } from '../P/P';

export const OL = styled(P)`

  list-style-type: lower-roman;

  padding-left: 20px;

`.withComponent('ol');



// WEBPACK FOOTER //
// ./src/components/LE/OL.js